import { setPreviewing } from '@sanity/svelte-loader';

// src/routes/+layout.js
export const load = ({ url, data }) => {
  setPreviewing(data.preview);

  return {
    ...data,
    url
  };
};
